import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { ProjectStatus } from '@cyberlabrs/helpers';

interface UpdateProjectStatusDto {
    projectStatus: ProjectStatus;
    endDate?: string | null;
}

const useHttpUpdateProjectStatus = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (projectId: string, projectStatus: ProjectStatus, onSuccess?: () => void, onError?: () => void, endDate?: string | null) => {
        const body: UpdateProjectStatusDto = {
            projectStatus,
            ...(endDate !== undefined && { endDate }),
        };

        const { exec: apiExec, abort } = projectApi.updateProjectStatus({
            params: { id: projectId },
            body,
            onSuccess: () => {
                toastHandler.push('success', t('projects.projectUpdateTitle'), t('projects.projectStatusUpdated'));
                onSuccess?.();
            },
            onError: () => {
                toastHandler.push('error', t('projects.projectUpdateTitle'), t('projects.projectStatusUpdateFailed'));
                onError?.();
            },
        });

        apiExec();
        return abort;
    };

    return { exec };
};

export default useHttpUpdateProjectStatus;
